var ranger;

ranger = function() {
  var $, module, moduleName, rangesliderJs;
  rangesliderJs = require('rangeslider-js');
  moduleName = 'ranger';
  $ = require('jquery');
  module = $("." + moduleName);
  if (module.length < 1) {
    return false;
  }
  return module.each(function() {
    var dataCell, options, thisMod;
    thisMod = $(this);
    dataCell = thisMod.find("." + moduleName + "__counter .datacell");
    options = {
      onInit: function(value, percent, position) {
        return dataCell.html(value);
      },
      onSlide: function(value, percent, position) {
        return dataCell.html(value);
      }
    };
    return rangesliderJs.create(this.querySelector('input[type=range]'), options);
  });
};

module.exports = ranger;
